import { fadeInOutDuration } from "./variables";
$(() => {
  $(".lesson__free").click(() => {
    $(".free__modal").fadeIn(fadeInOutDuration);
  });
  $(".free__modal--bg").click(() => {
    $(".free__modal").fadeOut(fadeInOutDuration);
  });
  $(".lesson__no-registration,.no-registration__like--button").click(() => {
    $(".no-registration__modal").fadeIn(fadeInOutDuration);
  });
  $(".no-registration__modal--bg").click(() => {
    $(".no-registration__modal").fadeOut(fadeInOutDuration);
  });
  $(".lesson__undone-getting-started").click(() => {
    $(".undone-getting-started__modal").fadeIn(fadeInOutDuration);
  });
  $(".undone-getting-started__modal--bg").click(() => {
    $(".undone-getting-started__modal").fadeOut(fadeInOutDuration);
  });
  $(".modal__popup_close_button").click(() => {
    $(
      ".no-registration__modal, .free__modal, .undone-getting-started__modal"
    ).fadeOut(fadeInOutDuration);
  });
});
